export default __webpack_public_path__ + "static/media/why.3053dbf3.png";